(() => {
  if (!window.location.pathname.startsWith('/products/')) return;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const STAIRS_LABEL = /^Stairs(?:\s+Option)?$/i;

  function isVisible(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function isStairsField(field) {
    const labels = field.querySelectorAll('label, legend, .gpo-label, [class*="gpo-label"]');
    return Array.from(labels).some((label) => STAIRS_LABEL.test(normalize(label.textContent)));
  }

  function resetStairsField(field) {
    field.querySelectorAll('select').forEach((select) => {
      const options = Array.from(select.options || []);
      const placeholder = options.find((option) =>
        /please\s*select/i.test(normalize(option.textContent)) || option.value === ''
      );

      if (placeholder && select.value !== placeholder.value) {
        select.value = placeholder.value;
        placeholder.selected = true;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function ensureContactNote(anchor) {
    let note = document.getElementById('gmc-stairs-contact-note-v6');
    if (!note) {
      note = document.createElement('div');
      note.id = 'gmc-stairs-contact-note-v6';
      note.innerHTML = '<strong>Stairs / restricted access:</strong> Please contact us before ordering so access requirements and any applicable charge can be confirmed.';
      note.style.border = '1px solid #e5e5e5';
      note.style.padding = '12px';
      note.style.margin = '12px 0';
      note.style.lineHeight = '1.45';
      anchor.insertAdjacentElement('beforebegin', note);
    }
  }

  function cleanStairs() {
    const fields = Array.from(document.querySelectorAll('.gpo-element')).filter(isStairsField);
    if (!fields.length) return;

    document.querySelectorAll('#gmc-stairs-contact-note-v3, #gmc-stairs-contact-note-v4').forEach((note) => note.remove());

    const anchor = fields.find(isVisible) || fields[0];
    ensureContactNote(anchor);

    fields.forEach((field) => {
      resetStairsField(field);
      field.style.setProperty('display', 'none', 'important');
      field.setAttribute('aria-hidden', 'true');
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      cleanStairs();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
